















































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { File, XvOrderResp_Order, XvUpdateOrderReq, XvUpdateOrderReq_Order, XvDeleteFileReq_FileType } from '@/apiv3/index'
import auth from '@/auth'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import helpers from '@/helpers'
import VueUploadComponent from 'vue-upload-component'
import { FileStatus } from '@/api'

@Component({ components: { PulseLoader, VueUploadComponent } })
export default class XvOrderEdit extends Vue {
  @Prop(String) id!: string

  public order!: XvOrderResp_Order
  public blocked = false
  public loaded = false
  public finishDate = ''
  public XvDeleteFileReq_FileType = XvDeleteFileReq_FileType
  public files: Array<VUFile> = []
  public workFiles: Array<File> = []
  public orderFiles: Array<File> = []

  $refs!: {
    upload: VueUploadComponent;
  }

  public inputFile (newFile: VUFile, oldFile: VUFile) {
    if (Boolean(newFile) !== Boolean(oldFile)) {
      this.$refs.upload.active = true
    }
  }

  public removeFileOrder (file: VUFile) {
    this.$refs.upload.remove(file)
  }

  public uploadChunk (): object {
    const res = {
      action: 'https://xvostov.net/api/v2/file',
      minSize: 1,
      maxActive: 3,
      maxRetries: 5
    }

    return res
  }

  mounted () {
    const id = helpers.getAmount(this.id)

    auth.adminClient().XvOrder({ id: BigInt(id) }).then((resp) => {
      if (resp.order) {
        this.order = resp.order
        this.finishDate = helpers.dateTsToInputValue(resp.order.finishDate)
        this.workFiles = this.order.workFiles
        this.orderFiles = this.order.orderFiles
        this.loaded = true
      }
    })
  }

  formatDate (val: string | undefined): string {
    return helpers.formatDate(val)
  }

  updateOrder () {
    if (this.order === undefined) {
      return
    }

    this.blocked = true

    this.order.finishDate = helpers.inputValueToDateTs(this.finishDate)

    const files: bigint[] = []

    this.files.forEach((_value: VUFile, index: number) => {
      const resp = this.$refs.upload.files[index.valueOf()].response as FileStatus
      files.push(BigInt(resp.id))
    })

    const order: XvUpdateOrderReq_Order = {
      comment: this.order.comment,
      demand: this.order.demand,
      discount: this.order.discount,
      finishDate: this.order.finishDate,
      lesson: this.order.lesson,
      prepayment: this.order.prepayment,
      price: this.order.price,
      seasonId: this.order.seasonId,
      size: this.order.size,
      theme: this.order.theme,
      type: this.order.type,
      workFiles: files
    }

    const req: XvUpdateOrderReq = {
      id: BigInt(helpers.getAmount(this.id)),
      order: order
    }

    auth.adminClient().XvUpdateOrder(req).then(() => {
      this.$router.push('/adm/xvostov')
    }).finally(() => {
      this.blocked = false
    })
  }

  public getFileURL (file: File, ord: XvOrderResp_Order | null): string {
    return helpers.getXvFileURL(file, ord)
  }

  removeFile (fileId: bigint, fileIdx: number, type: XvDeleteFileReq_FileType) {
    auth.adminClient().XvDeleteFile({ id: fileId, orderId: BigInt(helpers.getAmount(this.id)), type: type }).then(() => {
      if (type === XvDeleteFileReq_FileType.WORK) {
        this.workFiles.splice(fileIdx, 1)
      } else {
        this.orderFiles.splice(fileIdx, 1)
      }
    })
  }
}
